import React from 'react'
import { withStyles, Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';
import HelpIcon from '@material-ui/icons/Help';
import clsx from "clsx";
const style = theme => ({
	root: {

	},
	iconColor: {
		color: theme.palette.action.active
	},
	tooltipWidth: {
		maxWidth: 750
	}
})

function HelpTooltip({
	className,
	classes,
	text,
	dangerouslySetTextHTML
}) {
	return (
		<Tooltip classes={{ tooltip: classes.tooltipWidth }} title={!!dangerouslySetTextHTML ? <div dangerouslySetInnerHTML={{__html: dangerouslySetTextHTML}}/> : text}>
			<HelpIcon className={clsx(classes.iconColor, className)} />
		</Tooltip>
	)
}

HelpTooltip.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(HelpTooltip);